import { useSelector } from "react-redux";

export const hasPermission = (config, roleId) => {
  const userData = useSelector((x) => x?.auth?.value);
  if (!config) return false;

  if (roleId) {
    if (config.roleIds.includes(roleId)) {
      return true;
    }
  } else if (config.roleIds && config.roleIds.includes(userData?.role)) {
    return true;
  }

  return false;
};

export const permissionConfig = {
  adminAccess: {
    roleIds: [1, 6],
  },
  storeManagerAccess: {
    roleIds: [1, 6, 2],
  },
  vendorAccess: {
    roleIds: [1, 6,  3],
  },
  departmentAccess: {
    roleIds: [1,6, 4],
  },
  buyerAccess: {
    roleIds: [1, 6,  5],
  },
};
